import router from './index'
import store from '@/store'


const loadSiteRoutes = (templateRoute,siteInfo) => {
        let routes = [
          {
            path: '/',
            component: require(`@/views/${templateRoute}/index`).default,
            name: 'root',
            children: [

            ]
          },
          {
            path: '*',
            component: require(`@/views/${templateRoute}/features/index`).default,
            name:'features'
          }
        ]
        routes.forEach(item=>{
          router.addRoute(item)
        })

        try {
        // warning：传递给 require.context 的参数必须是字面量(literal)！
        // 取出所有page.js静态路由配置
        let modulesFiles = require.context('@/views',true,/page\.js$/)
        let pages = []
        let regTemplate = new RegExp(`\\b${templateRoute}\\b`)    // 只匹配当前站点模板页
        modulesFiles.keys().forEach((modulePath, index,modules) => {
            let page =  require(`@/views/${modulePath.replace(/\.\//,'')}`).default
            if(modulePath.match(regTemplate)){
                console.log('modulePath',modulePath)
                pages.push(page)
            }
        })
        pages = pages.sort((a,b)=>Boolean(b.name) - Boolean(a.name))
        store.commit('breadcrumb/setPagesRoute',pages)
        // 递归取出栏目所有路由信息（包括：nodeModel，infoModel）
        function recHandleRouteByNodes(nodes){
            let result = []
            function recHandle(children){
                if(children && children.length){
                    children.forEach(node=>{
                        if(node.nodeModel){
                            result.push(node.nodeModel.route)
                        }
                        if(node.infoModel){
                            result.push(node.infoModel.route)
                        }
                        if(node.children && node.children.length){
                            recHandle(node.children)
                        }
                    })
                }
            }
            recHandle(nodes)
            return [...new Set(result)].filter(i=>i)
        }
        console.log('pages',pages)
        let nodesRoute = recHandleRouteByNodes(siteInfo.nodes)
        console.log('nodesRoute',nodesRoute)
        let customRoute = pages.filter(page=>!nodesRoute.includes(page.mapPath)).sort((a,b)=>Boolean(b.name) - Boolean(a.name))
        console.log('customRoute',customRoute)
        let nodeRoute = null
        // 把page.js的信息与栏目路由进行匹配
        nodesRoute.forEach((route)=>{
            nodeRoute =  pages.find(page=>page.mapPath === route)
            if(nodeRoute){
                // 匹配则用静态配置的路由（好处：静态路由可灵活配置）
                if(nodeRoute.parent){
                    router.addRoute(nodeRoute.parent,nodeRoute)
                }else{
                    router.addRoute(nodeRoute)
                }
                // console.log('匹配',route,nodeRoute)
            }else{
                // 不匹配则直接取接口
                // console.log('不匹配',route)
                try {
                  router.addRoute('root',{
                      path:route,
                      component:require(`@/views/${siteInfo.templateRoute}${route}/index`).default
                  })
                } catch (error) {
                  console.log('error',error)
                }
            }
        })
        // 自定义路由
        customRoute.forEach(route=>{
            let {component,path,parent,name,children,meta} = route
            if(parent){
                router.addRoute(parent,{
                    name,
                    path,
                    component,
                    children,
                    meta
                })
            }else{
                router.addRoute(route)
            }
        })
        console.log('routes',router.getRoutes())
        } catch (error) {
            console.log('error',error)
        }
}


export {
    loadSiteRoutes,

}